let host = window.location.href;
let isProduction = true;  
console.log(
  isProduction
    ? "🚨🚨🚨🚨🚨🚨PRODUCTION🚨🚨🚨🚨🚨🚨"
    : "🚧🚧🚧🚧🚧DEVELOPMENT🚧🚧🚧🚧🚧🚧"
);

// ********* BASE URL ********
export const BASE_URL = isProduction
  ? "https://endpointpune.sociohood.com/api"
  : "https://v2backend.sociohood.com/api";
// export const BASE_URL = isProduction?"":"http://localhost:8005/api"

export const PUNE_URL = "https://dashboardpune.sociohood.com/";
export const JAMSHEDPUR_URL = "https://dashboard.sociohood.com/";
export const ACTIVE_VERSION = isProduction ? "1.0" : "1.0";

// ********* VERSION URL ********
export const VERSION_URL = isProduction
  ? "https://versionprod.sociohood.com/api"
  : "https://versionprod.sociohood.com/api";
